export default "__VITE_ASSET__Dw9vQ6S5__"